import React, { useState, useEffect, useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-moment';

const DashboardEmission = () => {
  const [csvEmissionData, setCsvEmissionData] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    try {
      const getEmission = async () => {
        const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/getEmission', {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          },
        });
        const data = await response.json();
        setCsvEmissionData(data);
      };
      getEmission();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const chartData = {
    labels: csvEmissionData
      ? csvEmissionData.map((entry) =>
          new Date(entry.dateEmission).toLocaleDateString()
        )
      : data.map((entry) => new Date(entry.dateEmission).toLocaleDateString()),
    datasets: [
      {
        label: 'CO2 Emission',
        data: csvEmissionData
          ? csvEmissionData.map((entry) => entry.co2Emission)
          : data.map((entry) => entry.co2Emission),
        backgroundColor: 'rgba(0, 0, 0, 1)',
        borderColor: 'rgba(0, 0, 0, 1)',
      },
      {
        label: 'Green Energy Production',
        data: csvEmissionData
          ? csvEmissionData.map((entry) => entry.greenEnergyProduction)
          : data.map((entry) => entry.greenEnergyProduction),
        backgroundColor: 'rgba(0, 255, 0, 0.5)',
        borderColor: 'rgba(0, 255, 0, 0.5)',
      },
    ],
  };

  return (
    <div id='content-body' className='col-12 '>
      <div style={{ width: '80%', margin: 'auto'}}>
      <div>{csvEmissionData.length > 0 && <Bar data={chartData}  height={300} />}</div>
      </div>
    </div>
  );
};


export default DashboardEmission;
